export function InventoryPagination({ page, count, onPage, disabled = false }: { page: number; count: number; onPage: (page: number) => void; disabled?: boolean }) {
  return <div className="actions pagination">
    <button aria-label="Предыдущая страница" disabled={disabled || page === 0} onClick={() => onPage(page - 1)}>Назад</button>
    <span>Страница {page + 1}</span>
    <button aria-label="Следующая страница" disabled={disabled || count < 100} onClick={() => onPage(page + 1)}>Далее</button>
  </div>;
}
